import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { LimitOffsetPaging } from '../../../core/models/paged-results/limit-offset-paging.model';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    imports: [NgbPagination]
})
export class PaginationComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  @Input() paging: LimitOffsetPaging;
  @Input() updateUrl = false;

  @Output() public pageChange = new EventEmitter<number>();

  onPageChange(page) {
    this.updatePageParam(page);
    this.pageChange.emit(page);
  }

  private updatePageParam(page) {
    if (this.updateUrl) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { page },
        queryParamsHandling: 'merge',
      });
    }
  }
}
